export const periodLabel = (m) => (m === 1 ? "Mensal" : `${m} meses`);

export const saving = (prices, m) => {
  const base = prices?.["1"];
  const v = prices?.[String(m)];
  if (!base || !v || m === 1) return 0;
  return Math.round((1 - v / (base * m)) * 100);
};

export const bestSaving = (plans, m) => Math.max(0, ...(plans || []).map((p) => saving(p.prices, m)));

export const planPrice = (p, m) => {
  const base = p.prices?.[String(m)];
  const founder = p.founder_prices?.[String(m)];
  return { base, final: founder ?? base, isFounder: founder !== undefined && founder !== null };
};

export const waLink = (n) => `https://wa.me/${String(n || "").replace(/\D/g, "")}`;
